import Wrapper from 'components/layouts/Wrapper/Wrapper';
import {
  DataList,
  Headers,
  LoadingSpinner,
  ToolBar,
  TopPaymentBar,
  TransactionStatsBar,
} from 'components/core';
import { transactionTabnavData } from 'constants/TabNavData';
import { CONFIG } from 'shared/configs/config';
import { useGetAllTransactionsQuery } from 'services/payoutsApi';
import ListEmpty from '../Common/ListEmpty/ListEmpty';
import { useEffect, useState } from 'react';
import { helperTransactions } from 'helpers/modules/helperTransactions';
import { isPermitted, useGetUserQuery } from 'services/userApi';

export const UpcomingTransactionsContainer = () => {
  const filterParams = {
    first: CONFIG.DATA_OVERALL_LIMIT,
    offset: 0,
    filter: {
      paid_at: { isNull: true },
      status: { notEqualTo: '"cancelled"' },
    },
  };
  const { data: user } = useGetUserQuery({});
  const { data, isSuccess, isLoading } = useGetAllTransactionsQuery(filterParams);

  const totalCount = isSuccess ? data?.payoutBatchTransfers?.totalCount : 0;

  const [getTransferAmount] = helperTransactions();
  const [enableSelect, setEnableSelect] = useState(false);
  // eslint-disable-next-line
  const [selectedRows, setSelectedRows] = useState([]);
  const [tlAmount, setTlAmount]: any = useState();
  const [selectedIds, setSelectedIds]: any = useState();

  const [visibleColumns, setVisibleColumns] = useState([]);
  const [filteredRow, setFilteredRow] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getTransferAmount(selectedRows, setTlAmount, setSelectedIds);
  }, [selectedRows]);

  const handlePaynowOption = () => {
    setEnableSelect(true);
    setSelectedIds(null);
    setSelectedRows([]);
  };

  return (
    <>
      {enableSelect && (
        <TopPaymentBar
          selectedRowsLength={selectedRows?.length}
          setEnableSelect={setEnableSelect}
          totalAmount={tlAmount}
          ids={selectedIds}
          isTransfer
        />
      )}
      <Wrapper additionalClasses="flex-col items-start" pageTitle="Payments">
        {isLoading && <LoadingSpinner />}
        <Headers
          headingContent="Payments"
          buttonLabel={'Pay Now'}
          isButtonVisibled={isSuccess && totalCount > 0 && isPermitted(user, 'paynow-option')}
          onClick={handlePaynowOption}
          isDisabled={enableSelect}
        />
        <ToolBar
          navigationData={transactionTabnavData}
          isShowOptionEnabled={false}
          visibleColumns={visibleColumns}
          filteredRow={filteredRow}
          isDownloadCsvButtonEnabled={isSuccess && totalCount !== 0}
          isDownloadCompleteData={false}
        />
        {isSuccess && (
          <>
            <TransactionStatsBar data={data?.payoutBatchTransfers} />
            {totalCount !== 0 ? (
              <DataList
                data={data?.payoutBatchTransfers?.nodes}
                tableType="transactions"
                tableWrapperType="grid-height-normal"
                isPagination
                subTabType="upcomingTransactions"
                enableSelect={enableSelect}
                setSelectedRows={setSelectedRows}
                setVisibleColumns={setVisibleColumns}
                setFilteredRow={setFilteredRow}
                hiddenColumnList={['paid_at']}
                isServerSidePagination={false}
              />
            ) : (
              <ListEmpty />
            )}
          </>
        )}
      </Wrapper>
    </>
  );
};
